import controller_0 from '@symfony/ux-react/dist/render_controller.js';
export default {
  'symfony--ux-react--react': controller_0,
};